import React, { FC, useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import { galleryStore } from "@/stores/gallery";
import { sensitiveWordCheck } from "@/utils/string";
import { Toast } from "@/components/Toast";
import Select from "@/pages/Gallery/components/Select";
import { galleryLangRecords } from "@/pages/Gallery/lang";
import { langStore } from "@noli/business";
import styles from "./index.module.scss";
import config from "@/config";

export const gallerySeed = (type?: boolean) => {
  const seed = !type
    ? sessionStorage.getItem("seed") || Math.random().toString(36).substr(2, 10)
    : Math.random().toString(36).substr(2, 10);
  sessionStorage.setItem("seed", seed);
  return seed;
};
const Search: FC<any> = (props) => {
  const { refs, inHeader } = props;
  const lang = langStore.tgt;
  const searchRef = useRef<any>();
  const { setGalleryData, setPageLoading, galleryData, empty } = galleryStore;
  const codeList = [
    {
      code: "sort_default",
      text: galleryLangRecords[lang]["Sort-by-Default"],
    },
    {
      code: "sort_latest",
      text: galleryLangRecords[lang]["Sort-by-Time"],
    },
    {
      code: "sort_most_like",
      text: galleryLangRecords[lang]["Sort-by-Likes"],
    },
  ];
  const authorList = [
    {
      code: "author_all",
      text: galleryLangRecords[lang]["AllAuthors"],
    },
    {
      code: "author_follow",
      text: galleryLangRecords[lang]["Concerned"],
    },
  ];
  const onSearch = async () => {
    setPageLoading(true);
    try {
      searchRef.current.value && (await sensitiveWordCheck(searchRef.current.value));
    } catch (e) {
      sessionStorage.keywords = "";
      searchRef.current.value = "";
      Toast({
        title: galleryLangRecords[lang]["Sensitive"],
        status: "warning",
      });
    } finally {
      setGalleryData({
        ...galleryData,
        page_index: 0,
      });
      setPageLoading(false);
      sessionStorage.keywords = searchRef.current.value;
    }
    if (location.pathname !== "/gallery") {
      location.href = "/gallery";
    }
  };
  const onSortSelect = (current: string) => {
    setGalleryData({
      ...galleryData,
      sort: current,
      page_index: 0,
    });
  };
  const onAuthorSelect = (current: string) => {
    setGalleryData({
      ...galleryData,
      author: current,
      page_index: 0,
    });
  };
  useEffect(() => {
    searchRef.current.value = sessionStorage.keywords || "";
  }, [sessionStorage.keywords, inHeader]);
  return (
    <div
      className={styles.searchMain}
      ref={refs}
      style={{
        flexFlow: inHeader ? "row-reverse" : "",
        justifyContent: inHeader ? "start" : "",
        width: inHeader ? "max-content" : "",
        marginLeft: inHeader ? "8vw" : "",
        flexGrow: inHeader ? 1 : 0,
      }}
    >
      {(location.pathname === "/gallery" || location.pathname === "/en/gallery") && (
        <div className={!inHeader ? styles.selectMain : ""}>
          <Select
            current={galleryData.sort}
            onSelect={onSortSelect}
            data={codeList}
            inHeader={inHeader}
          />
          {/*<Select current={galleryData.author} onSelect={onAuthorSelect} data={authorList} />*/}
        </div>
      )}
      <div className={styles.inputMain}>
        <div
          className={styles.inputWrapper}
          style={{
            marginTop: inHeader ? 0 : "",
            height: inHeader ? 40 : "",
            width: inHeader ? "21vw" : "",
            border: inHeader ? "1px solid #5F5F5F" : "",
          }}
          onClick={() => {
            searchRef?.current?.focus();
          }}
        >
          <img src={`${config.buildCdnBaseUrl}assets/creator/Icon%20-%20Search.png`} alt="" />
          <input
            defaultValue={sessionStorage.keywords}
            type="text"
            placeholder={galleryLangRecords[lang]["Search-for-an-image"]}
            ref={searchRef}
            onKeyDown={async (e) => {
              if (e.keyCode === 13) {
                // 回车
                await onSearch();
              }
            }}
          />
        </div>
        {empty && !inHeader && (
          <p
            className={styles.inputWrapper}
            style={{ background: "transparent", border: "none", justifyContent: "center" }}
          >
            没有找到相关的内容，可以看看这些推荐👇
          </p>
        )}
      </div>
    </div>
  );
};
export default observer(Search);
